import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  GetSiteDataUsageOptions,
  GetSiteDataUsageResponse,
  getSiteDataUsage as universalGetSiteDataUsage,
} from './cloud-data-usage-v1-site-data-usage-data.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/data-site-usage-service' };

/** @internal */
export function getSiteDataUsage(
  httpClient: HttpClient
): GetSiteDataUsageSignature {
  return (options?: GetSiteDataUsageOptions) =>
    universalGetSiteDataUsage(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetSiteDataUsageSignature {
  /**
   * Get current site data usage
   */
  (options?: GetSiteDataUsageOptions): Promise<
    NonNullablePaths<
      GetSiteDataUsageResponse,
      | `siteDataUsage.totalUsedLive.bytes`
      | `siteDataUsage.totalUsedLive.items`
      | `siteDataUsage.dataCollectionUsages`
      | `siteDataUsage.dataCollectionUsages.${number}.dataCollectionId`
      | `siteDataUsage.dataCollectionUsages.${number}.dataCollectionType`,
      5
    >
  >;
}

export {
  AccountInfo,
  Action,
  ActionEvent,
  BulkUpdateUsagesRequest,
  BulkUpdateUsagesResponse,
  ChangesLost,
  CollectionType,
  DataChangeEvent,
  DataChangeEventEventOneOf,
  DataChanged,
  DataChangedChangeOneOf,
  DataCollectionUsage,
  DataCollectionUsageUpdate,
  DataStore,
  DomainEvent,
  DomainEventBodyOneOf,
  Empty,
  Enrichment,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  GetSiteDataUsageOptions,
  GetSiteDataUsageRequest,
  GetSiteDataUsageResponse,
  IdentificationData,
  IdentificationDataIdOneOf,
  Identity,
  IgnoredSourceEvent,
  Initiator,
  InstanceUsageUpdate,
  MessageEnvelope,
  ReferenceChanged,
  RestoreInfo,
  Segment,
  SegmentChanged,
  SegmentMigrationStarted,
  SiteDataUsage,
  Type,
  Usage,
  WebhookIdentityType,
} from './cloud-data-usage-v1-site-data-usage-data.universal.js';
